"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ThemeProvider = void 0;
var _react = _interopRequireDefault(require("react"));
var _core = require("@material-ui/core");
var _hooks = require("../../hooks");
var _brand = require("../../utils/brand");
var _palette = require("../../assets/palette");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const getSignupRedesignOverrides = overrides => ({
  ...overrides,
  MuiInput: {
    ...overrides.MuiInput,
    input: {
      ...overrides.MuiInput?.input,
      borderRadius: '6px',
      borderColor: _palette.SIGNUP_REDESIGN_PALETTE.grey,
      padding: '0.5rem 0.75rem',
      color: _palette.SIGNUP_REDESIGN_PALETTE.black,
      '&::placeholder': {
        ...overrides.MuiInput?.input?.['&::placeholder'],
        color: _palette.SIGNUP_REDESIGN_PALETTE.secondary,
        opacity: 1
      }
    }
  },
  MuiTextField: {
    ...overrides.MuiTextField,
    root: {
      ...overrides.MuiTextField?.root,
      color: _palette.SIGNUP_REDESIGN_PALETTE.black,
      '& .MuiFormLabel-root': {
        ...overrides.MuiTextField?.root?.['& .MuiFormLabel-root'],
        color: _palette.SIGNUP_REDESIGN_PALETTE.black
      }
    }
  },
  MuiButton: {
    ...overrides.MuiButton,
    root: {
      ...overrides.MuiButton?.root,
      borderRadius: '6px',
      textTransform: 'none'
    }
  },
  MuiTypography: {
    ...overrides.MuiTypography,
    colorTextSecondary: {
      ...overrides.MuiTypography?.colorTextSecondary,
      color: _palette.SIGNUP_REDESIGN_PALETTE.secondary
    }
  },
  MuiPaper: {
    ...overrides.MuiPaper,
    rounded: {
      ...overrides.MuiPaper?.rounded,
      borderRadius: '8px'
    }
  }
});
const ThemeProvider = props => {
  const {
    theme,
    backgroundOverridden: isBackgroundOverridden = true,
    children
  } = props;
  const {
    brandId
  } = (0, _hooks.useConfig)();
  if ((0, _brand.getIsSignupDesignEnabled)(brandId)) {
    theme.overrides = getSignupRedesignOverrides(theme.overrides);
  }
  const themeWithConfig = (0, _hooks.useThemeWithConfig)({
    theme,
    isBackgroundOverridden
  });
  return /*#__PURE__*/_react.default.createElement(_core.MuiThemeProvider, {
    theme: themeWithConfig
  }, children);
};
exports.ThemeProvider = ThemeProvider;